import { useCallback, useEffect, useState } from 'react';
import learnerDataService from '../services/learnerDataService';

const initialState = {
  modules: [],
  progress: {},
  assignments: [],
  attendance: [],
  attendanceSummary: null,
  pendingSessions: [],
  documents: null,
  achievements: [],
  upcomingSessions: [],
  stats: null
};

const useLearnerData = (userId, userProfile) => {
  const [data, setData] = useState(initialState);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchData = useCallback(async () => {
    if (!userId) {
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const snapshot = await learnerDataService.getLearnerSnapshot(userId, userProfile);
      setData({
        modules: snapshot.modules || [],
        progress: snapshot.progress || {},
        assignments: snapshot.assignments || [],
        attendance: snapshot.attendance || [],
        attendanceSummary: snapshot.attendanceSummary || null,
        pendingSessions: snapshot.pendingSessions || [],
        documents: snapshot.documents || null,
        achievements: snapshot.achievements || [],
        upcomingSessions: snapshot.upcomingSessions || [],
        stats: snapshot.stats || null
      });
    } catch (err) {
      console.error('useLearnerData: failed to load learner data', err);
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [userId, userProfile]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return {
    ...data,
    loading,
    error,
    refresh: fetchData
  };
};

export default useLearnerData;
